// import { useState, useEffect, useRef } from "react";
// import { productCategoryApi, taxConfigApi } from "../api/api";
// import "./common.css";
// import { useResizableColumns } from "../hooks/useResizableColumns";
// import { usePagination } from "../hooks/usePagination";
// import Pagination from "../components/Pagination";

// /* ── Toast ── */
// function Toast({ message, type, onClose }) {
//   useEffect(() => {
//     const t = setTimeout(onClose, 3200);
//     return () => clearTimeout(t);
//   }, [onClose]);
//   return (
//     <div className={`rv-toast rv-toast--${type}`}>
//       <span className="rv-toast-icon">{type === "success" ? <CheckIcon /> : <AlertIcon />}</span>
//       <span className="rv-toast-msg">{message}</span>
//       <button className="rv-toast-close" onClick={onClose}><CloseIcon /></button>
//     </div>
//   );
// }

// /* ── Confirm Dialog ── */
// function ConfirmDialog({ name, onConfirm, onCancel }) {
//   return (
//     <div className="rv-dialog-backdrop">
//       <div className="rv-dialog">
//         <div className="rv-dialog-icon"><TrashIcon /></div>
//         <h3 className="rv-dialog-title">Delete Category?</h3>
//         <p className="rv-dialog-desc">
//           <strong>{name}</strong> will be permanently removed. This action cannot be undone.
//         </p>
//         <div className="rv-dialog-actions">
//           <button className="rv-btn rv-btn--ghost" onClick={onCancel}>Cancel</button>
//           <button className="rv-btn rv-btn--danger" onClick={onConfirm}>Delete</button>
//         </div>
//       </div>
//     </div>
//   );
// }

// /* ── Category Form Modal ── */
// function CategoryModal({ initial, categories, taxConfigs, onSave, onClose, saving }) {
//   const isEdit = !!initial?.categoryID;

//   const [form, setForm] = useState({
//     categoryName: initial?.categoryName ?? "",
//     parentCategoryID: initial?.parentCategoryID != null ? String(initial.parentCategoryID) : "",
//     taxConfigID: initial?.taxConfigID != null && initial.taxConfigID !== 0
//       ? String(initial.taxConfigID) : "",
//     codeHSN: initial?.codeHSN ?? "",
//   });
//   const [errors, setErrors] = useState({});

//   const validate = () => {
//     const e = {};
//     if (!form.categoryName.trim()) e.categoryName = "Category name is required.";
//     return e;
//   };

//   const handleSubmit = () => {
//     const e = validate();
//     if (Object.keys(e).length) { setErrors(e); return; }
//     onSave({
//       ...initial,
//       categoryName: form.categoryName.trim(),
//       parentCategoryID: form.parentCategoryID !== "" ? Number(form.parentCategoryID) : 0,
//         ? Number(form.parentCategoryID) : 0,
//       taxConfigID: form.taxConfigID !== "" ? Number(form.taxConfigID) : 0,
//         ? Number(form.taxConfigID) : 0,
//       codeHSN: form.codeHSN.trim(),
//     });
//   };

//   /* Exclude self from parent dropdown */
//   const parentOptions = categories.filter(
//     c => !isEdit || c.categoryID !== initial?.categoryID
//   );

//   /* De-duplicate tax configs by taxName — keep latest (highest taxConfigID) per name */
//   const uniqueTaxConfigs = Object.values(
//     taxConfigs.reduce((acc, t) => {
//       if (!acc[t.taxName] || t.taxConfigID > acc[t.taxName].taxConfigID) {
//         acc[t.taxName] = t;
//       }
//       return acc;
//     }, {})
//   ).sort((a, b) => a.taxName.localeCompare(b.taxName));

//   return (
//     <div className="rv-dialog-backdrop">
//       <div className="rv-dialog rv-dialog--form">
//         <div className="rv-modal-header">
//           <div className="rv-modal-icon"><CatIcon /></div>
//           <div>
//             <h3 className="rv-modal-title">{isEdit ? "Edit Category" : "New Category"}</h3>
//             <p className="rv-modal-sub">
//               {isEdit ? "Update the category details below." : "Fill in details to create a new product category."}
//             </p>
//           </div>
//           <button className="rv-modal-close" onClick={onClose}><CloseIcon /></button>
//         </div>

//         <div className="rv-modal-body">

//           {/* Category Name */}
//           <div className="rv-field">
//             <label className="rv-label">Category Name <span className="rv-required">*</span></label>
//             <input
//               className={`rv-input ${errors.categoryName ? "rv-input--err" : ""}`}
//               placeholder="e.g. Rings, Necklaces, Bracelets"
//               value={form.categoryName}
//               onChange={e => {
//                 setForm(f => ({ ...f, categoryName: e.target.value }));
//                 setErrors(v => ({ ...v, categoryName: "" }));
//               }}
//             />
//             {errors.categoryName && <p className="rv-field-err">{errors.categoryName}</p>}
//           </div>

//           {/* Parent Category */}
//           <div className="rv-field">
//             <label className="rv-label">Parent Category</label>
//             <p className="rv-field-hint">Leave empty for a top-level category</p>
//             <div className="rv-select-wrap">
//               <select
//                 className="rv-select"
//                 value={form.parentCategoryID}
//                 onChange={e => setForm(f => ({ ...f, parentCategoryID: e.target.value }))}
//               >
//                 <option value="">None (Top-level)</option>
//                 {parentOptions.map(c => (
//                   <option key={c.categoryID} value={c.categoryID}>
//                     {c.categoryName}
//                   </option>
//                 ))}
//               </select>
//               <span className="rv-select-arrow"><ChevronIcon /></span>
//             </div>
//           </div>

//           {/* Two-column row: Tax Config + HSN Code */}
//           <div className="rv-field-row-2col">

//             {/* Tax Config — dropdown from API */}
//             <div className="rv-field">
//               <label className="rv-label">Tax Config</label>
//               <div className="rv-select-wrap">
//                 <select
//                   className="rv-select"
//                   value={form.taxConfigID}
//                   onChange={e => setForm(f => ({ ...f, taxConfigID: e.target.value }))}
//                 >
//                   <option value="">None</option>
//                   {uniqueTaxConfigs.map(t => (
//                     <option key={t.taxConfigID} value={t.taxConfigID}>
//                       {t.taxName} ({t.taxPercentage}%)
//                     </option>
//                   ))}
//                 </select>
//                 <span className="rv-select-arrow"><ChevronIcon /></span>
//               </div>
//               {uniqueTaxConfigs.length === 0 && (
//                 <p className="rv-field-hint">No tax configs available.</p>
//               )}
//             </div>

//             {/* HSN Code */}
//             <div className="rv-field">
//               <label className="rv-label">HSN Code</label>
//               <input
//                 className="rv-input"
//                 placeholder="e.g. 7113"
//                 value={form.codeHSN}
//                 onChange={e => setForm(f => ({ ...f, codeHSN: e.target.value }))}
//               />
//             </div>
//           </div>

//         </div>

//         <div className="rv-modal-footer">
//           <button className="rv-btn rv-btn--ghost" onClick={onClose} disabled={saving}>Cancel</button>
//           <button className="rv-btn rv-btn--primary" onClick={handleSubmit} disabled={saving}>
//             {saving ? <span className="rv-spinner" /> : null}
//             {isEdit ? "Update" : "Create"}
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// }

// /* ══════════════════════════════════════
//    MAIN PRODUCT CATEGORY PAGE
// ══════════════════════════════════════ */
// export default function ProductCategoryPage() {
//   const [categories, setCategories] = useState([]);
//   const [taxConfigs, setTaxConfigs] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [search, setSearch] = useState("");
//   const [filterType, setFilterType] = useState("all"); // all | parent | child

//   const [modal, setModal] = useState(null);
//   const [saving, setSaving] = useState(false);
//   const [confirm, setConfirm] = useState(null);
//   const [toast, setToast] = useState(null);

//   /* ── Resizable columns ── */
//   const tableRef = useRef(null);
//   const [tableReady, setTableReady] = useState(false);

//   // Columns: #, Name, Parent, HSN Code, Tax Config, Actions
//   useResizableColumns(tableRef, tableReady, [50, 200, 160, 120, 160, 100]);

//   /* ── Fetch both categories and tax configs in parallel ── */
//   const fetchAll = async () => {
//     try {
//       setLoading(true);
//       setTableReady(false);
//       const [catData, taxData] = await Promise.all([
//         productCategoryApi.getAll(),
//         taxConfigApi.getAll(),
//       ]);
//       setCategories(Array.isArray(catData) ? catData : catData?.data ?? []);
//       setTaxConfigs(Array.isArray(taxData) ? taxData : taxData?.data ?? []);
//     } catch (err) {
//       showToast(err.message || "Failed to load data.", "error");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => { fetchAll(); }, []);

//   useEffect(() => {
//     if (!loading) setTableReady(true);
//   }, [loading]);

//   const showToast = (message, type = "success") => setToast({ message, type });

//   /* ── Helper: resolve parent name ── */
//   const getParentName = (parentCategoryID) => {
//     if (!parentCategoryID || parentCategoryID === 0) return null;
//     const parent = categories.find(c => c.categoryID === parentCategoryID);
//     return parent?.categoryName ?? `ID: ${parentCategoryID}`;
//   };

//   /* ── Helper: resolve tax config label ── */
//   const getTaxLabel = (taxConfigID) => {
//     if (!taxConfigID || taxConfigID === 0) return null;
//     const tax = taxConfigs.find(t => t.taxConfigID === taxConfigID);
//     if (!tax) return `ID: ${taxConfigID}`;
//     return `${tax.taxName} (${tax.taxPercentage}%)`;
//   };

//   /* ── Save ── */
//   const handleSave = async (formData) => {
//     setSaving(true);
//     try {
//       if (formData.categoryID) {
//         await productCategoryApi.update(formData);
//         showToast("Category updated successfully.");
//       } else {
//         await productCategoryApi.create(formData);
//         showToast("Category created successfully.");
//       }
//       setModal(null);
//       fetchAll();
//     } catch (err) {
//       showToast(err.message || "Something went wrong.", "error");
//     } finally {
//       setSaving(false);
//     }
//   };

//   /* ── Delete ── */
//   const handleDelete = async () => {
//     if (!confirm) return;
//     try {
//       await productCategoryApi.remove(confirm.id);
//       showToast("Category deleted.");
//       setConfirm(null);
//       fetchAll();
//     } catch (err) {
//       showToast(err.message || "Delete failed.", "error");
//     }
//   };

//   /* ── Filtered list ── */
//   const filtered = categories.filter(c => {
//     const parentName = getParentName(c.parentCategoryID) ?? "";
//     const taxLabel = getTaxLabel(c.taxConfigID) ?? "";
//     const matchSearch =
//       c.categoryName?.toLowerCase().includes(search.toLowerCase()) ||
//       c.codeHSN?.toLowerCase().includes(search.toLowerCase()) ||
//       parentName.toLowerCase().includes(search.toLowerCase()) ||
//       taxLabel.toLowerCase().includes(search.toLowerCase());

//     const isChild = c.parentCategoryID && c.parentCategoryID !== 0;
//     const matchType =
//       filterType === "all" ||
//       (filterType === "parent" && !isChild) ||
//       (filterType === "child" && isChild);

//     return matchSearch && matchType;
//   });
//   const {
//     paged, page, totalPages, pageSize,
//     setPage, setPageSize,
//     pageStart, pageEnd, totalItems,
//   } = usePagination(filtered, 10);

//   return (
//     <div className="rv-cat-page">

//       {toast && (
//         <Toast message={toast.message} type={toast.type} onClose={() => setToast(null)} />
//       )}
//       {confirm && (
//         <ConfirmDialog
//           name={confirm.name}
//           onConfirm={handleDelete}
//           onCancel={() => setConfirm(null)}
//         />
//       )}
//       {modal && (
//         <CategoryModal
//           initial={modal.data}
//           categories={categories}
//           taxConfigs={taxConfigs}
//           onSave={handleSave}
//           onClose={() => setModal(null)}
//           saving={saving}
//         />
//       )}

//       {/* ── Topbar ── */}
//       <div className="rv-cat-topbar">
//         <div className="rv-cat-topbar-left">
//           <h2 className="rv-cat-heading">Product Categories</h2>
//           <span className="rv-cat-count">{categories.length} total</span>
//         </div>
//         <button className="rv-btn rv-btn--primary" onClick={() => setModal({ data: {} })}>
//           <PlusIcon /> New Category
//         </button>
//       </div>

//       {/* ── Filters ── */}
//       <div className="rv-cat-filters">
//         <div className="rv-cat-search">
//           <SearchIcon />
//           <input
//             placeholder="Search by name, parent or HSN code…"
//             value={search}
//             onChange={e => { setSearch(e.target.value); setPage(1); }}
//           />
//           {search && (
//             <button className="rv-cat-search-clear" onClick={() => { setSearch(""); setPage(1); }}>
//               <CloseIcon />
//             </button>
//           )}
//         </div>

//         <div className="rv-filter-tabs">
//           {[
//             { key: "all", label: "All" },
//             { key: "parent", label: "Main Category" },
//             { key: "child", label: "Sub-category" },
//           ].map(({ key, label }) => (
//             <button
//               key={key}
//               className={`rv-filter-tab ${filterType === key ? "rv-filter-tab--active" : ""}`}
//               onClick={() => { setFilterType(key); setPage(1); }}
//             >
//               {label}
//             </button>
//           ))}
//         </div>
//       </div>

//       {/* ── Table card ── */}
//       <div className="rv-card rv-cat-card">
//         {loading ? (
//           <div className="rv-cat-empty">
//             <div className="rv-loader" />
//             <p>Loading categories…</p>
//           </div>
//         ) : filtered.length === 0 ? (
//           <div className="rv-cat-empty">
//             <div className="rv-empty-icon"><CatIcon /></div>
//             <p className="rv-empty-title">No categories found</p>
//             <p className="rv-empty-sub">
//               {search ? "Try a different search term." : "Create your first product category to get started."}
//             </p>
//             {!search && (
//               <button className="rv-btn rv-btn--primary rv-mt-12" onClick={() => setModal({ data: {} })}>
//                 <PlusIcon /> New Category
//               </button>
//             )}
//           </div>
//         ) : (
//           <>
//             <div className="rv-table-wrap rv-cat-table-wrap">
//               <table className="rv-table rv-cat-table" ref={tableRef}>
//                 <thead>
//                   <tr>
//                     <th>#</th>
//                     <th>Category Name</th>
//                     <th>Main Category</th>
//                     <th>HSN Code</th>
//                     <th>Tax Config</th>
//                     <th>Actions</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {paged.map((cat, i) => {
//                     const parentName = getParentName(cat.parentCategoryID);
//                     const taxLabel = getTaxLabel(cat.taxConfigID);
//                     return (
//                       <tr key={cat.categoryID} className="rv-cat-row">
//                         <td className="rv-cat-idx">{pageStart + i}</td>
//                         <td>
//                           <div className="rv-cat-name-cell">
//                             <span className="rv-cat-name">{cat.categoryName}</span>
//                           </div>
//                         </td>
//                         <td>
//                           {parentName ? (
//                             <span className="rv-parent-badge">{parentName}</span>
//                           ) : (
//                             <span className="rv-top-level-badge">Main Category</span>
//                           )}
//                         </td>
//                         <td>
//                           {cat.codeHSN ? (
//                             <span className="rv-hsn-badge">{cat.codeHSN}</span>
//                           ) : (
//                             <span className="rv-empty-val">—</span>
//                           )}
//                         </td>
//                         <td>
//                           {taxLabel ? (
//                             <span className="rv-tax-id-badge">{taxLabel}</span>
//                           ) : (
//                             <span className="rv-empty-val">—</span>
//                           )}
//                         </td>
//                         <td>
//                           <div className="rv-actions">
//                             <button
//                               className="rv-action-btn rv-action-btn--edit"
//                               title="Edit"
//                               onClick={() => setModal({ data: cat })}
//                             >
//                               <EditIcon />
//                             </button>
//                             <button
//                               className="rv-action-btn rv-action-btn--del"
//                               title="Delete"
//                               onClick={() => setConfirm({ id: cat.categoryID, name: cat.categoryName })}
//                             >
//                               <TrashIcon />
//                             </button>
//                           </div>
//                         </td>
//                       </tr>
//                     );
//                   })}
//                 </tbody>
//               </table>
//             </div>
//             <Pagination
//               page={page}
//               totalPages={totalPages}
//               pageSize={pageSize}
//               setPage={setPage}
//               setPageSize={setPageSize}
//               pageStart={pageStart}
//               pageEnd={pageEnd}
//               totalItems={totalItems}
//             />
//           </>
//         )}
//       </div>

//       {/* ── Resize hint ── */}
//       {!loading && filtered.length > 0 && (
//         <p className="rv-resize-hint">
//           <GripIcon /> Drag column borders to resize
//         </p>
//       )}
//     </div>
//   );
// }

// /* ── Icons ── */
// function PlusIcon() { return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" /></svg>; }
// function SearchIcon() { return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6"><circle cx="11" cy="11" r="8" /><line x1="21" y1="21" x2="16.65" y2="16.65" /></svg>; }
// function EditIcon() { return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" /><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" /></svg>; }
// function TrashIcon() { return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6"><polyline points="3 6 5 6 21 6" /><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" /><path d="M10 11v6" /><path d="M14 11v6" /><path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" /></svg>; }
// function CloseIcon() { return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>; }
// function CheckIcon() { return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="20 6 9 17 4 12" /></svg>; }
// function AlertIcon() { return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10" /><line x1="12" y1="8" x2="12" y2="12" /><line x1="12" y1="16" x2="12.01" y2="16" /></svg>; }
// function ChevronIcon() { return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="6 9 12 15 18 9" /></svg>; }
// function CatIcon() { return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6"><path d="M3 3h6l2 3H21a1 1 0 0 1 1 1v11a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z" /></svg>; }
// function GripIcon() { return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" style={{ width: 13, height: 13 }}><circle cx="9" cy="5" r="1" fill="currentColor" /><circle cx="9" cy="12" r="1" fill="currentColor" /><circle cx="9" cy="19" r="1" fill="currentColor" /><circle cx="15" cy="5" r="1" fill="currentColor" /><circle cx="15" cy="12" r="1" fill="currentColor" /><circle cx="15" cy="19" r="1" fill="currentColor" /></svg>; }


import { useState, useEffect, useRef, useMemo } from "react";
import { productCategoryApi, taxConfigApi } from "../api/api";
import "./common.css";
import { useResizableColumns } from "../hooks/useResizableColumns";
import { usePagination } from "../hooks/usePagination";
import Pagination from "../components/Pagination";
import SearchableDropdown from "../components/SearchableDropdown";

/* ── Toast ── */
function Toast({ message, type, onClose }) {
  useEffect(() => {
    const t = setTimeout(onClose, 3200);
    return () => clearTimeout(t);
  }, [onClose]);
  return (
    <div className={`rv-toast rv-toast--${type}`}>
      <span className="rv-toast-icon">{type === "success" ? <CheckIcon /> : <AlertIcon />}</span>
      <span className="rv-toast-msg">{message}</span>
      <button className="rv-toast-close" onClick={onClose}><CloseIcon /></button>
    </div>
  );
}

/* ── Confirm Dialog ── */
function ConfirmDialog({ name, onConfirm, onCancel, hasChildren, childNames }) {
  return (
    <div className="rv-dialog-backdrop">
      <div className="rv-dialog">
        <div className="rv-dialog-icon"><TrashIcon /></div>
        <h3 className="rv-dialog-title">Delete Category?</h3>
        {hasChildren ? (
          <>
            <p className="rv-dialog-desc" style={{ color: '#c2412c' }}>
              <strong>{name}</strong> has {childNames.length} sub-categor{childNames.length > 1 ? 'ies' : 'y'}:
            </p>
            <ul style={{
              margin: '12px 0',
              padding: '8px 12px',
              paddingLeft: '0',
              color: '#4a5a6a',
              maxHeight: '140px',
              overflowY: 'auto',
              backgroundColor: '#f8fafc',
              borderRadius: '10px',
              border: '1px solid #e4eaf2',
              listStyle: 'none',
              fontSize: '14px'
            }}>
              {childNames.map((childName, index) => (
                <li key={childName} style={{
                  padding: '8px 14px',
                  marginBottom: '2px',
                  borderRadius: '6px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '12px',
                  color: '#2c3e50',
                  transition: 'background-color 0.2s ease',
                  cursor: 'default'
                }}
                  onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#edf4fa'}
                  onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                >
                  <span style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '24px',
                    height: '24px',
                    backgroundColor: '#eef3fc',
                    borderRadius: '6px',
                    fontSize: '12px',
                    color: '#1a6b8f',
                    fontWeight: '700',
                    flexShrink: 0
                  }}>
                    {index + 1}
                  </span>
                  <span style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    flex: 1
                  }}>
                    <span style={{
                      display: 'inline-block',
                      width: '8px',
                      height: '8px',
                      background: 'linear-gradient(135deg, #1a6b8f, #4a9ac7)',
                      borderRadius: '50%',
                      flexShrink: 0
                    }}></span>
                    {childName}
                  </span>
                  <span style={{
                    fontSize: '16px',
                    opacity: 0.3
                  }}>
                    🏷️
                  </span>
                </li>
              ))}
            </ul>
            <p className="rv-dialog-desc" style={{ color: '#c2412c', fontWeight: '600' }}>
              Please delete all child categories first before deleting this parent category.
            </p>
          </>
        ) : (
          <p className="rv-dialog-desc">
            <strong>{name}</strong> will be permanently removed. This action cannot be undone.
          </p>
        )}
        <div className="rv-dialog-actions">
          <button className="rv-btn rv-btn--ghost" onClick={onCancel}>Cancel</button>
          {!hasChildren && (
            <button className="rv-btn rv-btn--danger" onClick={onConfirm}>Delete</button>
          )}
        </div>
      </div>
    </div>
  );
}

/* ── Category Form Modal ── */
function CategoryModal({ initial, categories, taxConfigs, onSave, onClose, saving, parentID }) {
  const isEdit = !!initial?.categoryID;

  const defaultParent = parentID != null ? String(parentID) : (initial?.parentCategoryID != null ? String(initial.parentCategoryID) : "");

  const [form, setForm] = useState({
    categoryName: initial?.categoryName ?? "",
    parentCategoryID: defaultParent,
    taxConfigID: initial?.taxConfigID != null && initial.taxConfigID !== 0
      ? String(initial.taxConfigID) : "",
    codeHSN: initial?.codeHSN ?? "",
  });
  const [errors, setErrors] = useState({});

  const validate = () => {
    const e = {};
    const nameTrim = form.categoryName.trim();
    if (!nameTrim) {
      e.categoryName = "Category name is required.";
    } else {
      const isDuplicate = categories.some(
        c => (!isEdit || c.categoryID !== initial?.categoryID) &&
             (c.categoryName || "").trim().toLowerCase() === nameTrim.toLowerCase()
      );
      if (isDuplicate) {
        e.categoryName = "A category with this name already exists.";
      }
    }

    if (!form.taxConfigID || form.taxConfigID === "0" || Number(form.taxConfigID) <= 0) {
      e.taxConfigID = "Tax configuration is required.";
    }

    const hsnTrim = form.codeHSN.trim();
    if (hsnTrim && !/^[0-9]{4,8}$/.test(hsnTrim)) {
      e.codeHSN = "HSN code must be 4 to 8 numeric digits (e.g. 7113).";
    }

    return e;
  };

  const handleSubmit = () => {
    const e = validate();
    if (Object.keys(e).length) { setErrors(e); return; }
    onSave({
      ...initial,
      categoryName: form.categoryName.trim(),
      parentCategoryID: form.parentCategoryID !== "" && form.parentCategoryID != null ? Number(form.parentCategoryID) : null,
      taxConfigID: form.taxConfigID !== "" && form.taxConfigID != null ? Number(form.taxConfigID) : null,
      codeHSN: form.codeHSN.trim(),
    });
  };

  const parentOptions = categories.filter(
    c => !isEdit || c.categoryID !== initial?.categoryID
  );

  const uniqueTaxConfigs = Object.values(
    taxConfigs.reduce((acc, t) => {
      if (!acc[t.taxName] || t.taxConfigID > acc[t.taxName].taxConfigID) {
        acc[t.taxName] = t;
      }
      return acc;
    }, {})
  ).sort((a, b) => a.taxName.localeCompare(b.taxName));

  return (
    <div className="rv-dialog-backdrop">
      <div className="rv-dialog rv-dialog--form rv-category-modal">
        <div className="rv-modal-header">
          <div className="rv-modal-icon"><CatIcon /></div>
          <div>
            <h3 className="rv-modal-title" style={{ fontSize: "16px", fontWeight: 600 }}>
              {isEdit ? "Edit Category" : "New Category"}
            </h3>
            <p className="rv-modal-sub" style={{ fontSize: "12px", marginTop: "2px" }}>
              {isEdit ? "Update category hierarchy, tax rules, and HSN code." : "Fill in details to create a new product category."}
            </p>
          </div>
          <button className="rv-modal-close" onClick={onClose}><CloseIcon /></button>
        </div>

        <div className="rv-modal-body">
          <div className="rv-field">
            <label className="rv-label" style={{ fontWeight: 600, fontSize: "12.5px" }}>
              Category Name <span className="rv-required">*</span>
            </label>
            <input
              className={`rv-input ${errors.categoryName ? "rv-input--err" : ""}`}
              placeholder="e.g. Rings, Necklaces, Bracelets"
              maxLength={150}
              value={form.categoryName}
              onChange={e => {
                setForm(f => ({ ...f, categoryName: e.target.value }));
                setErrors(v => ({ ...v, categoryName: "" }));
              }}
            />
            {errors.categoryName && <p className="rv-field-err">{errors.categoryName}</p>}
          </div>

          <div className="rv-field">
            <label className="rv-label" style={{ fontWeight: 600, fontSize: "12.5px" }}>
              Main Category (Parent)
            </label>
            <SearchableDropdown
              options={[
                { categoryID: "", categoryName: "None (This is a Main Category)" },
                ...parentOptions
              ]}
              valueKey="categoryID"
              labelKey="categoryName"
              value={form.parentCategoryID}
              onChange={val => setForm(f => ({ ...f, parentCategoryID: val }))}
              placeholder="None (This is a Main Category)"
              searchPlaceholder="Search parent categories…"
              pageSize={6}
            />
            <p className="rv-field-hint" style={{ marginTop: 2, fontSize: "11px" }}>
              Leave as "None" for a top-level category, or select a parent to create a sub-category.
            </p>
          </div>

          <div style={{ display: "grid", gridTemplateColumns: "1.4fr 1fr", gap: "16px" }}>
            <div className="rv-field">
              <label className="rv-label" style={{ fontWeight: 600, fontSize: "12.5px" }}>
                Tax Configuration <span className="rv-required">*</span>
              </label>
              <SearchableDropdown
                options={uniqueTaxConfigs.map(t => ({
                  taxConfigID: t.taxConfigID,
                  label: `${t.taxName} (${t.taxPercentage}%)`
                }))}
                valueKey="taxConfigID"
                labelKey="label"
                value={form.taxConfigID}
                onChange={val => {
                  setForm(f => ({ ...f, taxConfigID: val }));
                  setErrors(v => ({ ...v, taxConfigID: "" }));
                }}
                placeholder="Select tax configuration…"
                searchPlaceholder="Search tax rules…"
                error={errors.taxConfigID}
                pageSize={6}
              />
              {errors.taxConfigID && <p className="rv-field-err">{errors.taxConfigID}</p>}
              {uniqueTaxConfigs.length === 0 && (
                <p className="rv-field-hint">No tax configs available.</p>
              )}
            </div>

            <div className="rv-field">
              <label className="rv-label" style={{ fontWeight: 600, fontSize: "12.5px" }}>
                HSN Code
              </label>
              <input
                className={`rv-input ${errors.codeHSN ? "rv-input--err" : ""}`}
                placeholder="e.g. 7113"
                maxLength={8}
                value={form.codeHSN}
                onChange={e => {
                  const val = e.target.value.replace(/\D/g, "");
                  setForm(f => ({ ...f, codeHSN: val }));
                  setErrors(v => ({ ...v, codeHSN: "" }));
                }}
              />
              {errors.codeHSN && <p className="rv-field-err">{errors.codeHSN}</p>}
            </div>
          </div>
        </div>

        <div className="rv-modal-footer">
          <button className="rv-btn rv-btn--ghost" onClick={onClose} disabled={saving}>Cancel</button>
          <button className="rv-btn rv-btn--primary" onClick={handleSubmit} disabled={saving}>
            {saving ? <span className="rv-spinner" /> : null}
            {isEdit ? "Update Category" : "Create Category"}
          </button>
        </div>
      </div>
    </div>
  );
}

/* ══════════════════════════════════════
   MAIN PRODUCT CATEGORY PAGE
══════════════════════════════════════ */
export default function ProductCategoryPage() {
  const [categories, setCategories] = useState([]);
  const [leafCategories, setLeafCategories] = useState([]);
  const [taxConfigs, setTaxConfigs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [expandedIds, setExpandedIds] = useState(new Set());

  const [modal, setModal] = useState(null);
  const [saving, setSaving] = useState(false);
  const [confirm, setConfirm] = useState(null);
  const [toast, setToast] = useState(null);

  const tableRef = useRef(null);
  const [tableReady, setTableReady] = useState(false);

  useResizableColumns(tableRef, tableReady, [400, 150, 160, 120]);

  const fetchAll = async () => {
    try {
      setLoading(true);
      setTableReady(false);
      const [catData, taxData] = await Promise.all([
        productCategoryApi.getAll(),
        taxConfigApi.getAll(),
      ]);
      const fetchedCats = Array.isArray(catData) ? catData : catData?.data ?? [];
      const leafCats = fetchedCats.filter(c => c.parentCategoryID && c.parentCategoryID !== 0);
      setCategories(fetchedCats);
      setLeafCategories(leafCats);
      setTaxConfigs(Array.isArray(taxData) ? taxData : taxData?.data ?? []);

      const initialExpanded = new Set(fetchedCats.filter(c => !c.parentCategoryID).map(c => c.categoryID));
      setExpandedIds(initialExpanded);
    } catch (err) {
      showToast(err.message || "Failed to load data.", "error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchAll(); }, []);

  useEffect(() => {
    if (!loading) setTableReady(true);
  }, [loading]);

  const showToast = (message, type = "success") => setToast({ message, type });

  const getTaxLabel = (taxConfigID) => {
    if (!taxConfigID || taxConfigID === 0) return null;
    const tax = taxConfigs.find(t => t.taxConfigID === taxConfigID);
    if (!tax) return `ID: ${taxConfigID}`;
    return `${tax.taxName} (${tax.taxPercentage}%)`;
  };

  /* ── Get child categories for a given parent ID ── */
  const getChildCategories = (parentId) => {
    return categories.filter(c => c.parentCategoryID === parentId);
  };

  /* ── Check if category has children ── */
  const hasChildren = (categoryId) => {
    return categories.some(c => c.parentCategoryID === categoryId);
  };

  /* ── Save ── */
  const handleSave = async (formData) => {
    setSaving(true);
    try {
      if (formData.categoryID) {
        await productCategoryApi.update(formData);
        showToast("Category updated successfully.");
      } else {
        await productCategoryApi.create(formData);
        showToast("Category created successfully.");
        if (formData.parentCategoryID) {
          setExpandedIds(prev => new Set(prev).add(formData.parentCategoryID));
        }
      }
      setModal(null);
      fetchAll();
    } catch (err) {
      showToast(err.message || "Something went wrong.", "error");
    } finally {
      setSaving(false);
    }
  };

  /* ── Delete ── */
  const handleDelete = async () => {
    if (!confirm) return;
    try {
      // Check again if category has children (double-check)
      const children = getChildCategories(confirm.id);
      if (children.length > 0) {
        showToast(`Cannot delete "${confirm.name}" because it has ${children.length} sub-categor${children.length > 1 ? 'ies' : 'y'}. Please delete them first.`, "error");
        setConfirm(null);
        return;
      }

      await productCategoryApi.remove(confirm.id);
      showToast("Category deleted successfully.");
      setConfirm(null);
      fetchAll();
    } catch (err) {
      showToast(err.message || "Delete failed.", "error");
    }
  };

  /* ── Handle delete click - check for children first ── */
  const handleDeleteClick = (cat) => {
    const children = getChildCategories(cat.categoryID);
    setConfirm({
      id: cat.categoryID,
      name: cat.categoryName,
      hasChildren: children.length > 0,
      childNames: children.map(c => c.categoryName)
    });
  };

  /* ── Data Transformation: Flat to Tree ── */
  const { flatList } = useMemo(() => {
    const itemMap = {};
    const roots = [];

    categories.forEach(item => {
      itemMap[item.categoryID] = { ...item, children: [] };
    });

    categories.forEach(item => {
      if (item.parentCategoryID && itemMap[item.parentCategoryID]) {
        itemMap[item.parentCategoryID].children.push(itemMap[item.categoryID]);
      } else {
        roots.push(itemMap[item.categoryID]);
      }
    });

    const filterTree = (nodes, query) => {
      if (!query) return nodes;
      const lowerQuery = query.toLowerCase();
      return nodes.map(node => {
        const matches = node.categoryName?.toLowerCase().includes(lowerQuery) ||
          node.codeHSN?.toLowerCase().includes(lowerQuery);
        const filteredChildren = filterTree(node.children, query);

        if (matches || filteredChildren.length > 0) {
          return { ...node, children: filteredChildren, _isSearchMatch: matches };
        }
        return null;
      }).filter(Boolean);
    };

    const filteredTree = filterTree(roots, search);

    const flatten = (nodes, depth = 0) => {
      let result = [];
      nodes.forEach(node => {
        result.push({ ...node, depth });
        const isExpanded = search ? true : expandedIds.has(node.categoryID);
        if (isExpanded && node.children.length > 0) {
          result = result.concat(flatten(node.children, depth + 1));
        }
      });
      return result;
    };

    return { flatList: flatten(filteredTree) };
  }, [categories, expandedIds, search]);

  const toggleExpand = (id) => {
    setExpandedIds(prev => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id);
      else next.add(id);
      return next;
    });
  };
  const handleExpandAll = () => setExpandedIds(new Set(categories.map(c => c.categoryID)));
  const handleCollapseAll = () => setExpandedIds(new Set());

  const {
    paged, page, totalPages, pageSize,
    setPage, setPageSize,
    pageStart, pageEnd, totalItems,
  } = usePagination(flatList, 10);

  return (
    <div className="rv-cat-page">

      {toast && (
        <Toast message={toast.message} type={toast.type} onClose={() => setToast(null)} />
      )}
      {confirm && (
        <ConfirmDialog
          name={confirm.name}
          onConfirm={handleDelete}
          onCancel={() => setConfirm(null)}
          hasChildren={confirm.hasChildren}
          childNames={confirm.childNames}
        />
      )}
      {modal && (
        <CategoryModal
          initial={modal.data}
          parentID={modal.parentID}
          categories={leafCategories}
          taxConfigs={taxConfigs}
          onSave={handleSave}
          onClose={() => setModal(null)}
          saving={saving}
        />
      )}

      <div className="rv-cat-topbar">
        <div className="rv-cat-topbar-left">
          <h2 className="rv-cat-heading">Product Categories</h2>
          <span className="rv-cat-count">{categories.length} total</span>
        </div>
        <button className="rv-btn rv-btn--primary" onClick={() => setModal({ data: {}, parentID: "" })}>
          <PlusIcon /> New Category
        </button>
      </div>

      <div className="rv-cat-filters">
        <div className="rv-cat-search">
          <SearchIcon />
          <input
            placeholder="Search by name or HSN code…"
            value={search}
            onChange={e => { setSearch(e.target.value); setPage(1); }}
          />
          {search && (
            <button className="rv-cat-search-clear" onClick={() => { setSearch(""); setPage(1); }}>
              <CloseIcon />
            </button>
          )}
        </div>

        {!search && (
          <div className="rv-filter-tabs">
            <button className="rv-filter-tab" onClick={handleExpandAll}>Expand All</button>
            <button className="rv-filter-tab" onClick={handleCollapseAll}>Collapse All</button>
          </div>
        )}
      </div>

      <div className="rv-card rv-cat-card">
        {loading ? (
          <div className="rv-cat-empty">
            <div className="rv-loader" />
            <p>Loading categories…</p>
          </div>
        ) : flatList.length === 0 ? (
          <div className="rv-cat-empty">
            <div className="rv-empty-icon"><CatIcon /></div>
            <p className="rv-empty-title">No categories found</p>
            <p className="rv-empty-sub">
              {search ? "Try a different search term." : "Create your first product category to get started."}
            </p>
            {!search && (
              <button className="rv-btn rv-btn--primary rv-mt-12" onClick={() => setModal({ data: {}, parentID: "" })}>
                <PlusIcon /> New Category
              </button>
            )}
          </div>
        ) : (
          <>
            <div className="rv-table-wrap rv-cat-table-wrap">
              <table className="rv-table rv-cat-table" ref={tableRef}>
                <thead>
                  <tr>
                    <th>Category Name</th>
                    <th>HSN Code</th>
                    <th>Tax Config</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {paged.map((cat) => {
                    const hasChildren = cat.children && cat.children.length > 0;
                    const isExpanded = search ? true : expandedIds.has(cat.categoryID);
                    const taxLabel = getTaxLabel(cat.taxConfigID);
                    const hasChildCategories = getChildCategories(cat.categoryID).length > 0;

                    return (
                      <tr key={cat.categoryID} className={`rv-cat-row ${cat._isSearchMatch ? 'rv-row-highlight' : ''}`}>
                        <td>
                          <div
                            className="rv-cat-name-cell"
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: '8px',
                              paddingLeft: `${cat.depth * 1.5}rem`
                            }}
                          >
                            <div style={{ width: '24px', display: 'flex', justifyContent: 'center' }}>
                              {hasChildren ? (
                                <button
                                  onClick={() => toggleExpand(cat.categoryID)}
                                  style={{
                                    background: 'none', border: 'none', cursor: 'pointer', padding: '4px',
                                    transform: isExpanded ? 'rotate(90deg)' : 'rotate(0deg)',
                                    transition: 'transform 0.2s', color: 'inherit'
                                  }}
                                >
                                  <ChevronIcon />
                                </button>
                              ) : (
                                <span style={{ width: '6px', height: '6px', borderRadius: '50%', backgroundColor: '#cbd5e1' }} />
                              )}
                            </div>

                            <span className="rv-cat-name" style={{ fontWeight: cat.depth === 0 ? '600' : '400' }}>
                              {cat.categoryName}
                              {hasChildCategories && (
                                <span style={{
                                  marginLeft: '8px',
                                  fontSize: '11px',
                                  color: '#c25b1a',
                                  background: '#fff2e0',
                                  padding: '2px 8px',
                                  borderRadius: '12px'
                                }}>
                                  {getChildCategories(cat.categoryID).length} sub-categor{getChildCategories(cat.categoryID).length > 1 ? 'ies' : 'y'}
                                </span>
                              )}
                            </span>
                          </div>
                        </td>
                        <td>
                          {cat.codeHSN ? (
                            <span className="rv-hsn-badge">{cat.codeHSN}</span>
                          ) : (
                            <span className="rv-empty-val">—</span>
                          )}
                        </td>
                        <td>
                          {taxLabel ? (
                            <span className="rv-tax-id-badge">{taxLabel}</span>
                          ) : (
                            <span className="rv-empty-val">—</span>
                          )}
                        </td>
                        <td>
                          <div className="rv-actions">
                            <button
                              className="rv-action-btn"
                              title="Add Sub-category"
                              onClick={() => setModal({ data: {}, parentID: cat.categoryID })}
                            >
                              <PlusIcon />
                            </button>
                            <button
                              className="rv-action-btn rv-action-btn--edit"
                              title="Edit"
                              onClick={() => setModal({ data: cat })}
                            >
                              <EditIcon />
                            </button>
                            <button
                              className="rv-action-btn rv-action-btn--del"
                              title={hasChildCategories ? "Cannot delete - has sub-categories" : "Delete"}
                              onClick={() => handleDeleteClick(cat)}
                              style={hasChildCategories ? { opacity: 0.5, cursor: 'not-allowed' } : {}}
                            >
                              <TrashIcon />
                            </button>
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            <Pagination
              page={page}
              totalPages={totalPages}
              pageSize={pageSize}
              setPage={setPage}
              setPageSize={setPageSize}
              pageStart={pageStart}
              pageEnd={pageEnd}
              totalItems={totalItems}
            />
          </>
        )}
      </div>

      {!loading && flatList.length > 0 && (
        <p className="rv-resize-hint">
          <GripIcon /> Drag column borders to resize
        </p>
      )}
    </div>
  );
}

/* ── Icons ── */
function PlusIcon() { return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="16" height="16"><line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" /></svg>; }
function SearchIcon() { return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" width="20" height="20"><circle cx="11" cy="11" r="8" /><line x1="21" y1="21" x2="16.65" y2="16.65" /></svg>; }
function EditIcon() { return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" width="16" height="16"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" /><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" /></svg>; }
function TrashIcon() { return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" width="16" height="16"><polyline points="3 6 5 6 21 6" /><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" /><path d="M10 11v6" /><path d="M14 11v6" /><path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" /></svg>; }
function CloseIcon() { return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="16" height="16"><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>; }
function CheckIcon() { return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" width="24" height="24"><polyline points="20 6 9 17 4 12" /></svg>; }
function AlertIcon() { return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="24" height="24"><circle cx="12" cy="12" r="10" /><line x1="12" y1="8" x2="12" y2="12" /><line x1="12" y1="16" x2="12.01" y2="16" /></svg>; }
function ChevronIcon() { return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="16" height="16"><polyline points="9 18 15 12 9 6" /></svg>; }
function CatIcon() { return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" width="24" height="24"><path d="M3 3h6l2 3H21a1 1 0 0 1 1 1v11a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z" /></svg>; }
function GripIcon() { return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" style={{ width: 13, height: 13 }}><circle cx="9" cy="5" r="1" fill="currentColor" /><circle cx="9" cy="12" r="1" fill="currentColor" /><circle cx="9" cy="19" r="1" fill="currentColor" /><circle cx="15" cy="5" r="1" fill="currentColor" /><circle cx="15" cy="12" r="1" fill="currentColor" /><circle cx="15" cy="19" r="1" fill="currentColor" /></svg>; }